import { useState, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import promotionService from '../services/promotion.service'

export const usePromotions = () => {
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState<string>('all')

    const { data: promotions = [], isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['promotions'],
        queryFn: promotionService.getPromotions,
    })

    const filteredPromotions = useMemo(() => {
        return promotions.filter(promo => {
            const matchesSearch = promo.title.toLowerCase().includes(searchText.toLowerCase()) ||
                                  promo.subtitle.toLowerCase().includes(searchText.toLowerCase())
            const matchesStatus = statusFilter === 'all' || promo.status === statusFilter

            return matchesSearch && matchesStatus
        })
    }, [promotions, searchText, statusFilter])

    return {
        promotions: filteredPromotions,
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        totalPromotions: promotions.length,
        isLoading,
        isFetching,
        error,
        refetch,
    }
}
